// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"2794188a40fd7f36f722","873":"ebf6d0261eb2f565c60d"}[chunkId] + ".js";
};